<template>
  <li :class="classes" @click="emitClick">
    <slot></slot>
  </li>
</template>

<script lang="ts" setup>
import { computed } from "vue";

export interface DropdownItemProps {
  bordered?: boolean;
  disabled?: boolean;
  // TODO: Add text align as props, 'left' tw-text-left is default
}

const props = withDefaults(defineProps<DropdownItemProps>(), {
  bordered: false,
  disabled: false,
});

const classes = computed(() => {
  return [
    "tw-block tw-cursor-pointer tw-border-b tw-px-4 tw-py-2 tw-text-left tw-text-primary-grey-950",
    props.bordered ? "tw-border-primary-grey-50" : "tw-border-none",
    props.disabled
      ? "tw-pointer-events-none tw-text-primary-grey-200"
      : "hover:tw-bg-primary-grey-25",
  ];
});

const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};
</script>

<style scoped></style>
